export default __webpack_public_path__ + "static/media/office1-after1-1024w.35576a84.avif";